import { defineNuxtPlugin } from '#app';
import toastr from 'toastr';

export default defineNuxtPlugin(nuxtApp => {
    const notify = ({ title = '', text = '', type = 'success', duration = 5000, width = '50%' }) => {
        toastr.options.timeOut = duration;
        toastr.options.extendedTimeOut = duration;
        toastr.options.progressBar = true;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.toastClass = `toast toast-${type}`;

        const messageHtml = `<div><strong>${title}</strong><p>${text}</p></div>`;

        switch (type) {
            case 'success':
                toastr.success(messageHtml);
                break;
            case 'error':
                toastr.error(messageHtml);
                break;
            case 'info':
                toastr.info(messageHtml);
                break;
            case 'warning':
                toastr.warning(messageHtml);
                break;
            default:
                toastr.info(messageHtml);
                break;
        }
    };

    nuxtApp.provide('notify', notify);
});
